package com.battleships.quiz

/**
 * Difficulty tier for a question. Used to let a game mode pick easier
 * questions early on and harder ones later, or to mix difficulties evenly.
 */
enum class Difficulty {
    EASY, MEDIUM, HARD
}

/**
 * A single quiz question.
 *
 * @param id Unique identifier, used to avoid repeating questions in a session.
 * @param category Which topic this question belongs to, e.g. "git", "linux".
 * @param question The text shown to the player.
 * @param answers One or more accepted correct answers (lowercase, no spaces/hyphens).
 *                 Use a list when multiple phrasings should count as correct,
 *                 e.g. listOf("pr", "pullrequest").
 * @param difficulty How hard the question is. Defaults to MEDIUM so existing
 *                 calls to the Question constructor (with just 4 args) still compile.
 */
data class Question(
    val id: String,
    val category: String,
    val question: String,
    val answers: List<String>,
    val difficulty: Difficulty = Difficulty.MEDIUM
)
